/**
 * Utilitaire pour transformer les données de l'arbre des pièces
 * en structure organisée pour l'affichage
 */

import type { PartTreeResponse } from '../types/part.types';
import type { PartTreeCategory } from '../types/parts-by-vehicle.types';

/**
 * Transforme la réponse de l'API en structure de catégories
 * Le filtrage par vehicleType est déjà fait côté backend
 */
export function transformPartsTreeToCategories(partsTree: PartTreeResponse | undefined): PartTreeCategory[] {
  if (!partsTree?.categories) return [];

  // L'API retourne déjà les catégories formatées avec leurs pièces
  return partsTree.categories;
}
